<template>
  <div class="text-center max-100 text-break d-flex flex-column h-100 position-relative">
    <template v-if="!isEditMode">
      <div style="position: relative">
        <div class="text-left d-print-none" v-if="!hideTags && file.document_type > 0">
          <span class="badge badge-primary" style="position: absolute; left: 0.275rem; top: 0.275rem">{{
            documentType
          }}</span>
        </div>
        <a
          @click="$emit('imgClick', $event)"
          :href="disableLink ? 'javascript:void(0)' : fileUrl"
          :target="disableLink ? null : '_blank'"
          class="d-block h-100 img-link"
          :style="disableLink ? 'cursor:default' : ''"
        >
          <secure-img v-if="imgUrl" :url="imgUrl" @resolved="(e) => (imageResolvedUrl = e)" />
          <font-awesome-icon
            v-else
            :icon="getFileIcon(file)"
            style="font-size: 48px; margin: auto auto"
            class="d-block h-100"
          ></font-awesome-icon>
        </a>
        <div v-if="!hideTags && file.item_date" class="text-right d-print-none" style="">
          <span
            class="badge badge-secondary"
            style="position: absolute; right: 0px; bottom: 0.275rem"
            v-if="file.item_date"
            >{{ moment(file.item_date).format('ll') }}</span
          >
        </div>
      </div>
    </template>
    <div
      v-else
      class="d-flex flex-column align-items-center flex-grow-1 h-100 px-2 py-1 d-print-none"
      @keydown.esc="isEditMode = false"
    >
      <div class="editor p-2 my-auto text-left w-100 d-flex flex-column justify-content-between">
        <!-- <label>Filename</label>
        <input v-model="customName" ref="customName" class="form-control form-control-sm mb-2" @keydown.enter="updateFile" @focus="$event.target.select()" type="text" placeholder="File name"> -->

        <div class="">
          <label>Filename</label>
          <div class="input-group input-group-sm">
            <input
              v-model="customName"
              ref="customName"
              @keydown.enter="updateFile"
              @blur="updateFile"
              @focus="$event.target.select()"
              type="text"
              class="form-control"
              placeholder="File name"
            />
            <!-- <div class="input-group-append">
            <button class="btn btn-primary" type="button" @click="updateFile">
              <font-awesome-icon v-if="isSavingFile" icon="spinner-third" class="" size="sm" spin />
              <font-awesome-icon v-else icon="save" size="sm" class="" />
            </button>
          </div> -->
          </div>
        </div>
        <div class="form-check text-left pl-0 d-flex align-items-center my-3">
          <a href="javascript:void">
            <div class="custom-control custom-switch" style="cursor: pointer">
              <input
                v-model="isXray"
                type="checkbox"
                style="cursor: pointer"
                class="custom-control-input"
                name="is_xray"
                :id="`xraySwitch${file.id}`"
                @change="updateFile"
              />
              <label class="custom-control-label text-nowrap mb-0" :for="`xraySwitch${file.id}`">Is X-Ray</label>
            </div>
          </a>
        </div>
        <div class="xray-date">
          <label>Document date <small class="text-hint">(optional)</small></label>
          <datepicker
            @click.stop
            v-model="file.item_date"
            name="item_date"
            input-class="form-control form-control-sm"
            :bootstrap-styling="true"
            :disabledDates="{ from: new Date() }"
            @input="updateFile"
          >
            <!-- <div slot="afterDateInput" class="input-group-append">
              <button class="btn btn-sm btn-primary" @click.prevent.stop="onSubmitFileDate(file)" :disabled="isSavingDate || isSavingFile">

                <font-awesome-icon v-if="isSavingDate" icon="spinner-third" class="" size="sm" spin />
                <font-awesome-icon v-else icon="save" size="sm" class="" />
              </button>
            </div> -->
          </datepicker>
        </div>
      </div>
    </div>
    <slot name="afterIcon" v-if="!isEditMode">
      <div class="progress mt-1" v-if="!file.created_by && (file.active || file.progress !== '0.00')">
        <div
          :class="{
            'progress-bar': true,
            'progress-bar-striped': true,
            'bg-primary': file.success,
            'bg-danger': file.error,
            'progress-bar-animated': file.active,
          }"
          role="progressbar"
          :style="{ width: file.progress + '%' }"
        >
          {{ file.error ? 'Failed' : file.progress + '%' }}
        </div>
      </div>
      <div v-else-if="file.url">
        <a :href="fileUrl" target="_blank">{{ file.custom_name || file.name }}</a
        ><br />
        <small>{{ file.size | formatSize }}</small>
      </div>
      <div style="line-height: 0.9em">
        <small v-if="file.error" class="text-danger">{{ (file.response && file.response.url) || file.error }}</small>
        <small v-else-if="file.success">success</small>
        <!--todo: this will be obselete when the returned file is pushed to attachments and rendered with a link-->
        <small v-else-if="file.active">uploading...</small>
        <small v-else-if="file.updated_at"
          >by {{ $helpers.displayUsername(file.created_by) }}<br />
          {{ moment(file.updated_at).fromNow() }}</small
        >
        <span v-else></span>
      </div>
    </slot>
    <slot name="controls">
      <div v-if="isEditable" class="d-flex align-items-center justify-content-between px-2">
        <a
          v-if="showDelete && !isEditMode"
          class="d-print-none float-left"
          href="javascript:void(0);"
          @click.prevent.stop="onDeleteClick"
          :disabled="file.isDeleting"
        >
          <font-awesome-icon icon="spinner-third" v-if="file.isDeleting" spin />
          <font-awesome-icon :icon="['far', 'trash']" v-else />
        </a>
        <a v-if="!isEditMode" :href="fileUrl + '?download=true'" target="_blank" class="d-print-none">
          <font-awesome-icon :icon="['far', 'download']" />
        </a>
        <a
          class="d-print-none float-right"
          href="javascript:void(0);"
          @click.prevent.stop="isEditMode = !isEditMode"
          :style="isEditMode ? 'position:absolute; right:0;right: 0px; position: absolute; top:5px; right:10px' : ''"
        >
          <font-awesome-icon :icon="['far', isEditMode ? 'times' : 'pencil']" />
        </a>
        <!-- <template v-else>
          <a class="d-print-none" href="javascript:void(0);" @click.prevent.stop="isEditMode = !isEditMode">
            <font-awesome-icon :icon="['far', 'level-up']" />
          </a>
          <a class="d-print-none " href="javascript:void(0);" @click.prevent.stop="saveClick" :disabled="isSavingFile">
            <font-awesome-icon icon="spinner-third" v-if="isSavingFile" spin />
            <font-awesome-icon icon="save" size="lg" v-else />
          </a></template> -->
      </div>
      <div v-else class="text-muted text-right d-flex justify-content-between mx-3">
        <a :href="fileUrl + '?download=true'" target="_blank" class="d-print-none">
          <font-awesome-icon :icon="['far', 'download']" />
        </a>
        <small class="">{{ moment(file.item_date || file.updated_at).fromNow() }}</small>
      </div>
    </slot>
    <slot name="afterDetails">
      <!--todo: this should be its own vue component-->
      <div class="mt-1" v-if="file && file.updated_at">
        <div v-if="!file.isEditingItemDate">
          <span v-if="file.item_date">
            {{ moment(file.item_date).format('ll') }}
            <a href="javascript:void(0)" @click="toggleDateEditorForFile(file, true)">
              <small>edit</small>
            </a>
          </span>
          <a v-else href="javascript:void(0)" @click="toggleDateEditorForFile(file, true)">
            <small class="d-block">When was this document created?</small>
          </a>
        </div>
        <div v-else>
          <datepicker
            v-model="file.item_date"
            name="item_date"
            input-class="form-control form-control-sm"
            :bootstrap-styling="true"
            :disabledDates="{ from: new Date() }"
          >
            <!-- <div slot="afterDateInput" class="input-group-append">
              <button class="btn btn-sm btn-primary" @click.prevent.stop="onSubmitFileDate(file)" :disabled="isSavingDate">
                {{ isSavingDate ? 'Saving...' : 'Save' }}
              </button>
            </div> -->
          </datepicker>
        </div>
        <div>
          <a class href="javascript:void(0);" @click.prevent.stop="onDeleteClick" :disabled="file.isDeleting">
            <font-awesome-icon icon="spinner-third" v-if="file.isDeleting" spin />
            <font-awesome-icon :icon="['far', 'trash']" v-else />
          </a>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { AttachmentApi } from '@/services'
import Datepicker from 'vuejs-datepicker'
import Vue from 'vue'
import SecureImg from './SecureImg.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import { mapState } from 'vuex'

import client from '@/http-client'
export default {
  props: ['file', 'height', 'disableLink', 'referralId', 'showDelete', 'isReadOnly', 'hideTags'],
  data() {
    return {
      isSavingDate: false,
      imageResolvedUrl: null,
      isEditMode: false,
      isSavingFile: false,
      customName: this.file.custom_name || this.file.name,
      isEditingName: false,
      isDeleting: false,
      isXray: this.file.document_type == 1,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    imgUrl() {
      return this.getImageFile(this.file)
    },
    fileUrl() {
      return this.imgUrl ? this.imageResolvedUrl : this.$helpers.cdnUrl(this.file.url)
    },
    isEditable() {
      return !this.isReadOnly && this.file.created_by.practice_id == this.user.practice.id
    },
    documentType() {
      switch (this.file.document_type) {
        case 1:
          return 'X-ray'
        case 2:
          return 'Final Report'
        default:
          return
      }
    },
  },
  components: {
    Datepicker,
    SecureImg,
    VueCtkDateTimePicker,
  },
  methods: {
    getFileIcon: function (file) {
      if (!file) return
      if (file.type && file.type.toLowerCase().startsWith('image')) return 'file-image'
      const extension = file.name && file.name.split('.').pop()
      switch ((extension || '').toLowerCase()) {
        case 'pdf':
          return 'file-pdf'
        case 'jpg':
        case 'jfif':
        case 'gif':
        case 'jpeg':
        case 'png':
        case 'svg':
          return 'file-image'
      }
      return 'file'
    },
    getImageFile: function (file) {
      if (!file) return
      if (file.thumb) return file.thumb
      if (!file.updated_at) return
      if (file.type && file.type.toLowerCase().startsWith('image'))
        return file.file || (file.url && this.$helpers.cdnUrl(file.url)) || ''
      const extension = file.name && file.name.split('.').pop()
      switch ((extension || '').toLowerCase()) {
        case 'jpg':
        case 'gif':
        case 'jpeg':
        case 'png':
        case 'svg':
        case 'jfif':
          return this.$helpers.cdnUrl(file.url)
        // return `${process.env.VUE_APP_API_BASE_URL}/api/attachments/${file.id}/view`
      }
      return false
    },
    inputFile: function (newFile, oldFile) {
      if (newFile && !newFile.active) {
        newFile.active = true
        if (newFile && oldFile && newFile.success !== oldFile.success) {
          this.completedUploads = [newFile.response, ...this.completedUploads]
        }
      }
    },
    toggleDateEditorForFile(file, state) {
      Vue.set(file, 'isEditingItemDate', state)
    },
    onDeleteClick() {
      const _this = this
      this.$dialog
        .confirm(
          {
            title: 'Confirm Delete',
            body: 'Are you sure you want to delete this upload?',
          },
          { okText: 'Yes', cancelText: 'No' }
        )
        .then(async () => {
          _this.isDeleting = true
          await this.$store.dispatch('referrals/deleteAttachment', {
            referralId: _this.file.referral,
            attachmentId: _this.file.id,
          })
          // await AttachmentApi.delete(_this.file.id)
          _this.isDeleting = false
          _this.$emit('deleted', _this.file.id)
        })
    },
    async updateFile() {
      this.isSavingFile = true
      this.file.custom_name = this.customName || this.file.name
      await AttachmentApi.patch(this.file.id, {
        item_date: this.file.item_date,
        custom_name: this.file.custom_name,
        document_type: this.isXray ? 1 : 0,
      })
      this.isSavingFile = false
      this.isEditingName = false
    },
    saveClick() {
      this.updateFile()
      this.isEditMode = false
    },
    onSubmitFileDate(file) {
      const _this = this
      this.isSavingDate = true
      AttachmentApi.patch(file.id, { item_date: this.file.item_date })
        .then(() => Vue.set(file, 'isEditingItemDate', false))
        .finally(() => (_this.isSavingDate = false))
    },
  },
}
</script>
<style scoped>
.as-link {
  cursor: pointer;
}

.max-100 img {
  max-width: 100%;
  max-height: 100%;
}
label {
  font-weight: 500;
  color: var(--body-color);
  margin-bottom: 0px;
  font-size: 0.8rem;
}
</style>